import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import AreaField from './AreaField';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';

import './index.css';

export default (element, store) => {
  const root = createRoot(element);
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <AreaField
          editable={element.dataset.editable === 'True'}
          fieldId={element.dataset.id}
          choices={element.dataset.choices && JSON.parse(element.dataset.choices)}
          values={element.dataset.values && element.dataset.values.split('###')}
          column={element.dataset.column}
          row={element.dataset.row}
          width={element.dataset.width}
          height={element.dataset.height}
          photo={element.dataset.photo}
          verticalOffset={element.dataset.verticalOffset}
        />
      </Provider>
    </ErrorBoundary>,
  );

  return () => {
    root.unmount();
  };
};
